"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancellationTokenSource = void 0;
var cancellation_util_1 = require("./cancellation-util");
var MutableToken = /** @class */ (function () {
    function MutableToken() {
        this.isCancelled = false;
    }
    MutableToken.prototype.cancel = function () {
        if (!this.isCancelled) {
            this.isCancelled = true;
        }
    };
    Object.defineProperty(MutableToken.prototype, "isCancellationRequested", {
        get: function () {
            return this.isCancelled;
        },
        enumerable: false,
        configurable: true
    });
    return MutableToken;
}());
var CancellationTokenSource = /** @class */ (function () {
    function CancellationTokenSource() {
        this.innertoken = undefined;
    }
    Object.defineProperty(CancellationTokenSource.prototype, "token", {
        get: function () {
            if (!this.innertoken) {
                this.innertoken = new MutableToken();
            }
            return this.innertoken;
        },
        enumerable: false,
        configurable: true
    });
    CancellationTokenSource.prototype.cancel = function () {
        if (!this.innertoken) {
            this.innertoken = cancellation_util_1.CancellationTokenState.Cancelled;
        }
        else if (this.innertoken instanceof MutableToken) {
            this.innertoken.cancel();
        }
    };
    CancellationTokenSource.prototype.dispose = function () {
        this.cancel();
    };
    return CancellationTokenSource;
}());
exports.CancellationTokenSource = CancellationTokenSource;
//# sourceMappingURL=cancellation.js.map